export const formatRut = (rut) => {
  if (rut === null || rut === undefined || rut === "") return "No disponible";
  const limpio = String(rut).replace(/\./g, "").replace(/-/g, "").replace(/\s/g, "").toUpperCase();
  if (limpio.length < 2) return String(rut);
  const cuerpo = limpio.slice(0, -1);
  const dv = limpio.slice(-1);
  const cuerpoFormateado = cuerpo.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return `${cuerpoFormateado}-${dv}`;
};

export const formatDate = (value) => {
  if (!value) return "No disponible";
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    const d = String(value.getDate()).padStart(2, "0");
    const m = String(value.getMonth() + 1).padStart(2, "0");
    return `${d}-${m}-${value.getFullYear()}`;
  }
  const text = String(value).trim();
  const match = text.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (match) return `${match[3]}-${match[2]}-${match[1]}`;
  const already = text.match(/^(\d{2})[-/](\d{2})[-/](\d{4})/);
  if (already) return `${already[1]}-${already[2]}-${already[3]}`;
  return text;
};
